import { render, staticRenderFns } from "./commercial-lease.vue?vue&type=template&id=f58d3ed2&"
import script from "./commercial-lease.vue?vue&type=script&lang=js&"
export * from "./commercial-lease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports